import { Schema } from "@effect/schema";
import { satisfies } from "effect/Function";
import { LINKS } from "./links";

export const PointsKey = Schema.Literal(
  "eigenLayer",
  "renzo",
  "etherFi",
  "kelp",
  "swell",
  "mellow",
  "symbiotic",
  "bedrock",
  "turtle",
  "anzen"
).annotations({
  identifier: "PointsKey",
});

export type PointsKey = typeof PointsKey.Type;
export const pointsKeys = PointsKey.literals;
export const isPointsKey = Schema.is(PointsKey);

export type PointsItem = typeof PointsItem.Type;
export type PointsItemEncoded = typeof PointsItem.Encoded;

export const PointsItem = Schema.Struct({
  _tag: PointsKey,
  label: Schema.optional(Schema.String),
}).annotations({ identifier: "PointsItem" });

export type PointsConfig = typeof PointsConfig.Type;
export type PointsConfigEncoded = typeof PointsConfig.Encoded;

export const PointsConfig = Schema.Struct({
  defaultLabel: Schema.String,
  link: Schema.NullOr(Schema.String),
}).annotations({ identifier: "PointsConfig" });

export const POINTS_CONFIG = satisfies<Record<PointsKey, PointsConfig>>()({
  eigenLayer: {
    defaultLabel: "EigenLayer",
    link: null,
  },
  renzo: {
    defaultLabel: "Renzo",
    link: LINKS.RENZO_POINTS,
  },
  etherFi: {
    defaultLabel: "EtherFi",
    link: LINKS.ETHER_FI,
  },
  kelp: {
    defaultLabel: "Kelp Miles",
    link: LINKS.KELP_DAO_DASHBOARD,
  },
  swell: {
    defaultLabel: "Swell Pearls",
    link: LINKS.SWELL_POINTS,
  },
  mellow: {
    defaultLabel: "Mellow",
    link: LINKS.MELLOW_POINTS,
  },
  symbiotic: {
    defaultLabel: "Symbiotic",
    link: LINKS.SYMBIOTIC_POINTS,
  },
  bedrock: {
    defaultLabel: "Diamonds",
    link: LINKS.BEDROCK_POINTS,
  },
  turtle: {
    defaultLabel: "Turtle",
    link: LINKS.TURTLE_POINTS,
  },
  anzen: {
    defaultLabel: "Anzen points",
    link: LINKS.ANZEN_POINTS,
  },
} as const);

export function getPointsConfig(pointsKey: PointsKey): PointsConfig {
  return POINTS_CONFIG[pointsKey];
}

export function getPointsLabel(pointsItem: PointsItem): string {
  return pointsItem.label ?? POINTS_CONFIG[pointsItem._tag].defaultLabel;
}
